<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">账号:</div>
                <el-input v-model="conditionData.phone" size="small" placeholder="请输入"></el-input>
            </div>
            <!-- <div class="item">
                <div class="label">状态:</div>
                <el-select v-model="conditionData.yanZhiGrade" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                
               
            </div> -->
            <div class="btns">
                <el-button type="primary" size="small" @click="search()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                
            </div>
            <div class="list">
                <div class="picList">
                    <div class="pic" v-for="(item,index) in tableData" :key="index">
                        <el-image
                        style="width: 200px; height: 200px"
                        :src="item.faceHeader+'?imageView2/1/w/200/h/200'"
                        :preview-src-list="[item.faceHeader]"
                        fit="cover"></el-image>
                        <div class="pic-city">
                            {{ item.city }}
                        </div>
                        <div class="pic-static" v-if="item.yanZhiGrade==1">
                            {{ item.yanZhiGrade==1?'高颜值':'' }}
                        </div>
                        <div class="pic-edit" @click="editPicf(item)">
                            <i class="el-icon-edit" style="color:#ffffff"></i>
                        </div>
                        <div class="pic-state" v-if="item.state==1">
                            {{ item.state==1?'正常':'' }}
                        </div>
                        <div class="pic-state pic-stateb" v-else>
                            {{ item.state==-3?'拉黑':'' }}
                            {{ item.state==-2?'注销':'' }}
                            {{ item.state==-1?'冻结':'' }}
                        </div>
                        <!-- <img src="../../../assets/images/icon08.png" class="pic-edit" alt="" @click="editPic(item)"> -->
                        <div class="pic-con">
                            <div class="pic-con-name">{{ item.nickName}}</div>
                            <div class="pic-con-phone">{{ item.phone}}</div>
                            <div class="pic-con-edit">
                                <el-button type="text" size="mini" @click="dialogTip(item)">操作</el-button>
                            </div>
                        </div>
                        <!-- <img src="../../../assets/images/icon08.png" class="pic-static" alt="" @click="delPicTip(item)"> -->
                    </div>
                </div>

            </div>

            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[21, 35, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>



        <el-dialog :close-on-click-modal="false" :visible.sync="isAduitListDialog" title="审核" width="400px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        审核状态:
                    </div>
                    <el-select v-model="yanZhiGrade" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in stateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                </div>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAduitListDialog = false">取 消</el-button>
                    <el-button type="primary" @click="aduit">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDialogTip" :title="selectItem.nickName" width="400px">
            <div class="dialog">
                
                <div class="valuet" style="margin-bottom:20px">
                    <el-input v-model="reason" size="small" placeholder="请输入" type="textarea" :rows="4"></el-input>
                </div>
                <el-button type="primary" @click="LaHei">拉 黑</el-button>
                <el-button type="primary" @click="dongjie">冻 结</el-button>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isDialogTip = false">取 消</el-button>
                </div>
            </div>
        </el-dialog>

        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
           queryList:[
                {
                    type: "input",
                    label: "查询:",
                    name: "Keyword",
                },
                {
                    type: "select",
                    label: "状态:",
                    name: "state",
                    
                },
            ],
            conditionData: {
                phone: "",
                yanZhiGrade: null,
                current:1,
                size:21
            }, 
            stateList:[{
                label:'一般',
                value:0,
            },{
                label:'高颜值',
                value:1,
            }],
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            addData:{},
            updateData:{},
            tableData:[
               
            ],
            isAduitDialog:false,
            aduitData:{
                userId:0,
                state:0,
            },
            multipleSelection:[],

            isAduitListDialog:false,
            aduitListData:{},

            showBigImgList:[],
            showBigImg:false,
            yanZhiGrade:1,

            isFrozenDialog:false,
            isAddBackDialog:false,

            isDialogTip:false,
            selectItem:{
                
            },
            frozenData:{},
            reason:'太丑'
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        // 冻结提示
        dongjieTip(item){
            console.log(item);
            this.frozenData.userId = this.selectItem.userId;
            this.frozenData.reason = this.reason;
        },
        async dongjie(){
            
            this.frozenData.userId = this.selectItem.userId;
            this.frozenData.reason = this.reason;
            let res = await api.AdminStandFrozen(this.frozenData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '冻结成功!'
                });
                this.isDialogTip =false;
                this.loadingData();
            }
        },
        addBacktTip(row){
            console.log(row);
           
        },
        async LaHei(){
            console.log('LaHei');
            console.log(this.selectItem);
            this.addBackData = {
                userId:this.selectItem.userId,
                reason:this.reason,
                phone: this.selectItem.phone,
                nickName: this.selectItem.nickName,
                weChat: this.selectItem.weChat,
                device: this.selectItem.device,
            }
            let res = await api.LaHei(this.addBackData);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '拉黑成功'
                }); 
                this.isDialogTip = false;
                this.loadingData();

            }
        },
        dialogTip(item){
            console.log(item);
            this.isDialogTip = true;
            this.selectItem = item;
            console.log(this.selectItem);
        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(url){
            this.showBigImgList = [url];
            this.showBigImg = true;

        },
       
        isOpen(row){
            window.open(row.videoPath, '_blank')
        },
        isAduitDialogOpen(row){
            this.aduitData.userId = row.userId;
            this.aduitData.state = 1;
            this.title = row.nickName+'-'+row.phone;
            this.isAduitDialog = true;
        },
        deleteDialogOpen(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.AdminUserFileDeleteUserVideoFile(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },

        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        
        
        async AdminUserFileDeleteUserVideoFile(row){
            let res = await api.AdminUserFileDeleteUserVideoFile([{
                "userId": row.userId,
                "state": row.state
            }]);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                }); 
                this.loadingData();
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.UserInfoZhenRen(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        search(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        
        reset(){
            this.conditionData = {
                phone: "",
                yanZhiGrade: null,
                current:1,
                size:21,
            },
            this.loadingData();
        },
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        showAddDialog(){
            this.title = '新增角色';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        
        
        async aduit(){
            this.aduitListData.yanZhiGrade = this.yanZhiGrade
            let res  = await api.UpdateYanZhiGrade(this.aduitListData);
            if(res.data.code == '200') {
                this.$message({
                    message: '审核成功',
                    type: 'success'
                });
                this.isAduitListDialog = false;
                this.loadingData();
            }
        },
        isUpdateDialogShow(row){
            this.title = '编辑角色信息';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
        },
        editPic(row){
            this.isAduitListDialog = true;
            this.aduitListData = {
                "userId": row.userId,
                "yanZhiGrade": this.yanZhiGrade
            };

            console.log(row);
        },
        async editPicf(row){
            this.aduitListData = {
                "userId": row.userId,
                "yanZhiGrade": row.yanZhiGrade=='1'?'0':'1'
            };
            let res  = await api.UpdateYanZhiGrade(this.aduitListData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.isAduitListDialog = false;
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }

    .picList{
        display: flex;
        flex-wrap: wrap;
        .pic{
            position: relative;
            margin: 10px;
            width: 200px;
            border-radius: 10px;
            overflow: hidden;
            border: 1px solid #cccccc;
            .pic-city{
                position: absolute;
                z-index: 10;
                bottom: 67px;
                left: 10px;
                font-size: 12px;
                background-color: rgba(0, 0, 0, .3);
                color: #ffffff;
                height: 24px;
                line-height: 24px;
                border-radius: 12px;
                padding: 0 10px;
            }
            .pic-static{
                position: absolute;
                z-index: 10;
                top: 10px;
                left: 10px;
                padding: 0 10px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(246, 0, 94, 1);
                cursor: pointer;
                color: #ffffff;
                font-size: 12px;
                border-radius: 12px;
                i{
                    color: #ffffff;
                }
                .error{
                    color: #f56c6c;
                }
                .success{
                    color: #a9ffa9;
                }
            }
            .pic-edit{
                position: absolute;
                z-index: 10;
                top: 0;
                right: 0;
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(0, 0, 0 , 0.6);
                cursor: pointer;
                
            }
            .pic-state{
                width: 50px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(0, 0, 0 , 0.6);
                position: absolute;
                z-index: 10;
                bottom: 68px;
                right: 10px;
                color: #ffffff;
                font-size: 12px;
                border-radius: 12px;
            }
            .pic-stateb{
                color: red;
            }
            .pic-con{
                padding-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .pic-con-edit{
                    position: absolute;
                    right:10px;
                    padding-bottom: 2px;
                }
                .pic-con-name{
                    margin-top: 2px;
                }
                .pic-con-phone{
                    padding-bottom: 10px;
                }
            }

        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                margin-right: 10px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
